import React, { useEffect } from "react"
import GlobalStyle from "@styles/globals"
import "@styles/index.scss"

import { PageChrome } from "@utils/cmsPage"

const v2ChromeLayoutStyles = `
  .v2-legacy-page {
    --v2-ink: #0b1f2a;
    --v2-muted: #475569;
    --v2-soft: #f8fafc;
    --v2-line: #e2e8f0;
    --v2-teal: #0f766e;
    background: #fff;
    color: var(--v2-ink);
  }

  .v2-legacy-page section {
    overflow: hidden;
  }

  .v2-legacy-page h1,
  .v2-legacy-page h2,
  .v2-legacy-page h3,
  .v2-legacy-page h4 {
    color: var(--v2-ink);
    letter-spacing: 0;
  }

  .v2-legacy-page h1 {
    max-width: 920px;
    margin-left: auto;
    margin-right: auto;
    font-size: clamp(2.5rem, 5vw, 4.75rem);
    line-height: .98;
  }

  .v2-legacy-page h2 {
    font-size: clamp(2rem, 3.4vw, 3.25rem);
    line-height: 1.04;
  }

  .v2-legacy-page p,
  .v2-legacy-page li,
  .v2-legacy-page .typography__Paragraph-bEtLzD,
  .v2-legacy-page [class*="Paragraph"] {
    color: var(--v2-muted);
    line-height: 1.65;
  }

  .v2-legacy-page a[href]:not(.logo):not(.mc-footer a):not(.mc-nav a):not(.nav-dd-menu a):not([class*="link__StyledLink"]) {
    border-radius: 8px;
  }

  .v2-legacy-page .gatsby-image-wrapper img {
    border-radius: 8px;
  }

  .v2-legacy-page .layout__Section-kCXemr:first-of-type,
  .v2-legacy-page > [data-datocms-noindex] > section:first-child {
    background:
      radial-gradient(circle at 18% 8%, rgba(20, 184, 166, .12), transparent 30%),
      linear-gradient(180deg, #f0fdfa 0%, #fff 76%);
  }

  .v2-legacy-page .layout__Container-bIqfBJ {
    max-width: 1200px;
  }

  .v2-legal-page > section:first-child {
    padding-top: 112px;
  }

  .v2-extension-page,
  .v2-legal-page {
    --v2-page-heading: #10211f;
    --v2-page-body: #344844;
  }

  .v2-extension-page h1,
  .v2-extension-page h2,
  .v2-legal-page h1,
  .v2-legal-page h2 {
    color: var(--v2-page-heading);
    font-family: 'Graphik', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 1.08;
  }

  .v2-extension-page h1,
  .v2-legal-page h1 {
    font-size: clamp(2.5rem, 6vw, 4.75rem);
  }

  .v2-extension-page h1 {
    font-size: clamp(2.25rem, 4.4vw, 3.5rem);
  }

  .v2-extension-page h2,
  .v2-legal-page h2 {
    font-size: clamp(2rem, 4vw, 3.25rem);
  }

  .v2-extension-page h2 {
    font-size: clamp(1.875rem, 3.2vw, 2.75rem);
  }

  .v2-extension-page h3,
  .v2-legal-page h3 {
    color: var(--v2-page-heading);
    font-family: 'Graphik', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: clamp(1.35rem, 2vw, 1.75rem);
    font-weight: 600;
    letter-spacing: 0;
    line-height: 1.18;
  }

  .v2-extension-page p,
  .v2-extension-page li,
  .v2-extension-page [data-datocms-noindex] span,
  .v2-legal-page p,
  .v2-legal-page li {
    color: var(--v2-page-body);
    font-family: 'Graphik', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: clamp(1rem, 1.4vw, 1.125rem);
    line-height: 1.65;
  }

  .v2-extension-page h6 {
    align-self: flex-start;
    background: rgba(20, 184, 166, .12);
    border: 1px solid rgba(15, 118, 110, .18);
    border-radius: 999px;
    color: #0f766e;
    display: inline-flex;
    font-family: 'Graphik', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .12em;
    line-height: 1;
    margin-bottom: 1rem;
    padding: .46rem .72rem;
    text-transform: uppercase;
  }

  .v2-extension-page [data-datocms-noindex] > section:first-child p {
    color: #334844;
    font-size: clamp(1.0625rem, 1.6vw, 1.25rem);
  }

  .v2-legal-page [class*="Content"] {
    max-width: 880px;
    margin: 0 auto;
    padding: 40px;
    border: 1px solid var(--v2-line);
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 18px 48px -32px rgba(11, 31, 42, .24);
  }

  .v2-legal-page [class*="Content"] h1:first-child,
  .v2-legal-page [class*="Content"] h2:first-child {
    margin-top: 0;
  }

  .v2-legal-page [class*="Content"] h1:first-child {
    text-align: center;
  }

  .v2-legal-page [class*="Content"] h1:first-child + p,
  .v2-legal-page [class*="Content"] h2:first-child + p {
    color: #51645f;
    font-size: clamp(1.0625rem, 1.6vw, 1.25rem);
    line-height: 1.65;
    margin-bottom: 2rem;
  }

  .v2-proof-page [class*="cards__Card"] {
    height: 100%;
    border: 1px solid var(--v2-line);
    border-radius: 8px;
    box-shadow: 0 18px 42px -30px rgba(11, 31, 42, .28);
  }

  .v2-proof-page [class*="cards__Card"] a {
    height: 100%;
  }

  .v2-proof-page [class*="cards__Card"] p {
    color: #334155;
  }

  .v2-affiliates-page [data-datocms-noindex] > section:first-child {
    text-align: center;
  }

  .v2-affiliates-page [data-datocms-noindex] > section:first-child a,
  .v2-affiliates-page [data-datocms-noindex] > section:last-child a {
    margin: 10px 6px 0;
    background: #0f766e;
    color: #fff;
    border-color: #0f766e;
    border-radius: 8px;
  }

  .v2-affiliates-page [data-datocms-noindex] > section:nth-child(2) {
    background: #fff;
  }

  .v2-affiliates-page [data-datocms-noindex] > section:nth-child(2) [class*="layout__Flex"] {
    max-width: 1200px;
    margin: 0 auto 40px;
    padding: 32px;
    border: 1px solid var(--v2-line);
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 18px 50px -34px rgba(11, 31, 42, .28);
  }

  .v2-affiliates-page [data-datocms-noindex] > section:nth-child(2) [class*="layout__Column"] {
    min-width: 0;
  }

  .v2-extension-page [data-datocms-noindex] > section:first-child,
  .v2-feature-detail-page [data-datocms-noindex] > section:first-child,
  .v2-market-page [data-datocms-noindex] > section:first-child {
    padding-top: 112px;
  }

  .v2-extension-page {
    overflow-x: hidden;
  }

  .v2-extension-page [data-datocms-noindex] > section {
    max-width: 100vw;
    padding-left: clamp(18px, 4vw, 32px);
    padding-right: clamp(18px, 4vw, 32px);
  }

  .v2-extension-page [data-datocms-noindex] > section > [class*="layout__Container"],
  .v2-extension-page [data-datocms-noindex] > section > div[class*="Container"] {
    max-width: 1200px;
    min-width: 0;
    width: 100%;
  }

  .v2-extension-page [data-datocms-noindex] [class*="layout__Flex"] {
    margin-left: 0;
    margin-right: 0;
    min-width: 0;
    width: 100%;
  }

  .v2-extension-page [data-datocms-noindex] [class*="layout__Column"] {
    min-width: 0;
  }

  .v2-extension-page [data-datocms-noindex] [class*="layout__Content"],
  .v2-extension-page [data-datocms-noindex] [class*="typography"],
  .v2-extension-page [data-datocms-noindex] p,
  .v2-extension-page [data-datocms-noindex] li {
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  .v2-extension-page [data-datocms-noindex] .slick-slider,
  .v2-extension-page [data-datocms-noindex] .slick-list,
  .v2-extension-page [data-datocms-noindex] .slick-track,
  .v2-extension-page [data-datocms-noindex] .gatsby-image-wrapper,
  .v2-extension-page [data-datocms-noindex] img,
  .v2-extension-page [data-datocms-noindex] video {
    max-width: 100%;
  }

  .v2-extension-page [data-datocms-noindex] .slick-list {
    overflow: hidden;
  }

  .v2-extension-page [data-datocms-noindex] > section,
  .v2-feature-detail-page [data-datocms-noindex] > section,
  .v2-market-page [data-datocms-noindex] > section {
    border-bottom: 1px solid rgba(226, 232, 240, .76);
  }

  .v2-extension-page video,
  .v2-feature-detail-page video,
  .v2-market-page video {
    border-radius: 8px;
  }

  .v2-feature-detail-page [data-datocms-noindex] > section:first-child [class*="layout__Column"]:last-child,
  .v2-market-page [data-datocms-noindex] > section:first-child [class*="layout__Column"]:last-child,
  .v2-extension-page [data-datocms-noindex] > section:first-child [class*="layout__Column"]:last-child {
    padding: 24px;
    border: 1px solid rgba(15, 118, 110, .18);
    border-radius: 8px;
    background: rgba(255, 255, 255, .72);
    box-shadow: 0 24px 54px -36px rgba(15, 118, 110, .36);
  }

  @media (max-width: 960px) {
    .v2-legacy-page h1,
    .v2-legacy-page h2,
    .v2-legacy-page h3,
    .v2-legacy-page p {
      text-align: center;
    }

    .v2-legal-page [class*="Content"] {
      padding: 24px 18px;
    }

    .v2-extension-page h1,
    .v2-extension-page h2 {
      max-width: none;
      text-align: center;
    }

    .v2-extension-page h6 {
      align-self: center;
    }

    .v2-legal-page h1,
    .v2-legal-page h2 {
      text-align: center;
    }

    .v2-legal-page p,
    .v2-legal-page li {
      text-align: left;
    }

    .v2-affiliates-page [data-datocms-noindex] > section:nth-child(2) [class*="layout__Flex"] {
      padding: 22px 16px;
    }

    .v2-extension-page [data-datocms-noindex] [class*="layout__Column"] {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      width: 100% !important;
    }

    .v2-extension-page [data-datocms-noindex] > section:first-child [class*="layout__Column"]:last-child {
      padding: 0;
      border: 0;
      background: transparent;
      box-shadow: none;
    }
  }

  .v2-blog-page {
    overflow: visible;
  }

  .v2-blog-page h1 {
    font-size: clamp(2rem, 3.6vw, 3rem) !important;
    line-height: 1.08 !important;
    max-width: 880px;
  }

  .v2-blog-page h2 {
    font-size: clamp(1.75rem, 2.8vw, 2.5rem) !important;
    line-height: 1.14 !important;
  }

  .v2-blog-page h3 {
    font-size: clamp(1.25rem, 1.8vw, 1.5rem) !important;
    line-height: 1.2 !important;
  }

  #mc-nav .mc-nav {
    z-index: 100;
  }

  .v2-blog-page .blog-subnav,
  .v2-blog-page .navBlog__Nav-jBzScS {
    position: sticky !important;
    top: 77px !important;
    z-index: 90 !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    background: rgba(255, 255, 255, .96) !important;
    border-top: 0 !important;
    box-shadow: 0 1px 0 rgba(226, 232, 240, .9);
  }

  .v2-blog-page .blog-subnav > div:first-child,
  .v2-blog-page .navBlog__Nav-jBzScS > div:first-child {
    min-height: 64px;
  }

  .v2-blog-page .blogCategories ul,
  .v2-blog-page .blogSearch form {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .v2-blog-page .blogCategories ul {
    min-height: 64px;
    align-items: center;
  }

  .v2-blog-page .blogSearch form {
    min-height: 64px;
  }

  @media (max-width: 1024px) {
    .v2-blog-page .blog-subnav,
    .v2-blog-page .navBlog__Nav-jBzScS {
      top: 73px !important;
    }
  }

  @media (max-width: 768px) {
    .v2-blog-page .blog-subnav,
    .v2-blog-page .navBlog__Nav-jBzScS {
      top: 73px !important;
    }

    .v2-blog-page .blog-subnav > div:first-child,
    .v2-blog-page .navBlog__Nav-jBzScS > div:first-child,
    .v2-blog-page .blogCategories ul,
    .v2-blog-page .blogSearch form {
      min-height: 56px;
    }
  }
`

const normalizePath = value => {
  const path = `/${String(value || "").replace(/^\/+|\/+$/g, "")}`
  return path === "/" ? "/" : path.replace(/\/+$/g, "")
}

/**
 * `legacyTypography` controls the `v2-legacy-page` class, whose rules normalise bare tags
 * (`h1`-`h4`, `p`, `li`, `a[href]`) for pages whose markup predates the V2 design system.
 * They are unscoped and load after page-level styles, so on a page that owns its own design
 * they silently win: `.v2-legacy-page h1 { color: var(--v2-ink) }` repaints a white heading
 * dark navy, and the `p`/`li` colour rule does the same to body copy on dark sections.
 *
 * Pass `legacyTypography={false}` from a page that ships a self-contained design system (see
 * src/pages/affiliates.js). Defaults to `true`, so every existing page is unaffected.
 *
 * `robots` overrides PageChrome's default robots meta, e.g. "noindex, nofollow" for an unlisted
 * page (src/pages/capital.js).
 */
const V2ChromeLayout = ({
  children,
  title = "MoonClerk",
  description = "MoonClerk resources, guides, and product updates.",
  canonicalPath = "/",
  pageClassName = "",
  legacyTypography = true,
  robots,
}) => {
  const normalizedPath = normalizePath(canonicalPath)

  useEffect(() => {
    const node = document.createElement("script")
    node.src = "/assets/mc-chrome.js"
    node.async = false
    document.body.appendChild(node)

    return () => {
      node.remove()
    }
  }, [normalizedPath])

  return (
    <>
      <GlobalStyle />
      <style>{v2ChromeLayoutStyles}</style>
      <PageChrome
        title={title}
        description={description}
        canonicalPath={normalizedPath}
        seo={robots ? { robots } : undefined}
      />
      <div id="mc-nav" />
      <a className="cms-skip-link" href="#main">Skip to content</a>
      <main
        id="main"
        className={[
          "cms-page",
          legacyTypography ? "v2-legacy-page" : "",
          pageClassName,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {children}
      </main>
      <div id="mc-footer" />
    </>
  )
}

export default V2ChromeLayout
